export default {
  chart: {
    backgroundColor: 'transparent',
    width: 500,
    height: 400,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    enabled: false,
  },
  legend: {
    enabled: false,
    itemStyle: {
      color: '#fff',
    },
  },
  title: {
    text: '',
    style: {
      color: '#fff',
      fontFamily: 'Montserrat',
      fontWeight: '700',
      textShadow: '1px 1px #000',
    },
  },
  plotOptions: {
    line: {
      lineWidth: 4,
      states: {
        hover: {
          enabled: false
        }
      }
    },
    scatter: {
      marker: {
        radius: 1.5,
      },
    }
  },
  yAxis: {
    title: {
      text: ''
    },
    gridLineWidth: 0,
    labels: {
      style: {
        color: '#fff',
        fontFamily: 'Roboto',
        fontWeight: '700',
      },
    }
  },
  xAxis: {
    labels: {
      style: {
        color: '#fff',
        fontFamily: 'Roboto',
        fontWeight: '700',
      },
    }
  },
  series: [{
    type: 'line',
    name: '',
    color: '#fff',
    marker: {
      enabled: false,
    },
    data: [[3, 0], [4, 28], [5, 144], [6, 309], [7, 511], [8, 758], [9, 1017], [10, 1285], [11, 1504], [12, 1637], [13, 1650],
    [14, 1650], [15, 1650], [16, 1650]],
  }/*,
  {
    type: 'line',
    name: '',
    color: '#187BBD',
    marker: {
      enabled: false,
    },
    data: [[3, 0], [4, 25], [5, 111], [6, 300], [7, 488], [8, 700], [9, 999], [10, 1220], [11, 1488], [12, 1537], [13, 1630],
    [14, 1650], [15, 1650], [16, 1650]],
  }*/] 
}